import { useQuery } from "@tanstack/react-query";
import LeadApi from "../api/LeadApi";

export const useLeadsData = ({
  page,
  limit,
  queryString = "",
  queryParams = "",
  ofCompany,
  sort = "-enrolledOn",
  enabled = true,
}) => {
  console.log("Fetching enrollment with:", {
    page,
    limit,
    queryString,
    queryParams,
    ofCompany,
    sort,
  });
  const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
    queryKey: ["enrollment", page, limit, queryString, queryParams, ofCompany, sort], // Ensure `page` is part of the key
    queryFn: () =>
      LeadApi.fetchLeads({
        page,
        limit,
        queryString,
        queryParams,
        ofCompany,
        populate: "ofCompany,assignedTo,lastUpdationBy",
        selectPopulate: "name",
        sort,
      }),
    enabled,
    keepPreviousData: true, // Retain previous data during fetching
    staleTime: 30 * 1000,
    cacheTime: 30 * 1000,
    refetchInterval: 15 * 60 * 1000, // Refetch every 15 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // console.log("Set Query Key:", [
  //   "leads",
  //   page,
  //   limit,
  //   queryString,
  //   queryParams,
  //   ofCompany,
  //   sort,
  // ]);

  return { data, isLoading, isError, error, isFetching, refetch };
};
